<template>
  <div class="xl:pr-6 container">
    <div class="">

      <AlertSichernConnectNotificacion
        v-model="showExpiredPasswordAlert"
        color="info"
        class="mb-4"
        :title="$t('message.sichernConnect.modal.notification.infoPasswordTitle')"
        :message="$t('message.sichernConnect.modal.notification.infoPasswordMessage')"
        :shown-button-close="true"
      />

      <div v-if="!requestedList" class="empty-state">
        <vue-loading
          :active="!requestedList"
          color="#4F41A3"
          :is-full-page="false"
        />
      </div>
      <main v-else class="lg:pt-4 main--container">
        <DocumentsList
          :windowWidth="windowSize.width"
          :setDocumentId="setDocumentId"
        />
        <DocumentDetail :key="documentId" v-if="!isMobile" />
        <IframeDocumentDownload v-if="iframeTokenValid"/>
      </main>
    </div>
  </div>
</template>

<script>
import DocumentsList from './DocumentsList'
import DocumentDetail from './DocumentDetail'
import IframeDocumentDownload from './IframeDocumentDownload.vue'
import AlertSichernConnectNotificacion from '@/components/SichernConnect/AlertSichernConnectNotificacion.vue'
import { mapState, mapActions } from 'vuex'
import { useWindowResize } from '@sichern/ui-elements'

export default {
  name: 'Documents',
  components: {
    DocumentsList,
    DocumentDetail,
    IframeDocumentDownload,
    AlertSichernConnectNotificacion
  },
  created() {
    if (this.isInboxDocumentActivated) {
      this.setInitialDocumentsInbox()
    } else {
      this.setInitialDocuments()
    }
    this.setActions()
  },
  data() {
    return {
      documentId: '',
      windowSize: useWindowResize(this),
      loading: false,
      dismissedExpiredAlert: false
    }
  },
  methods: {
    ...mapActions('documents', ['setInitialDocuments', 'setInitialDocumentsInbox']),
    ...mapActions(['setActions']),
    setDocumentId(id) {
      this.documentId = id
    }
  },
  computed: {
    ...mapState('documents', ['unsigned', 'signed', 'documents', 'requestedList']),
    isMobile() {
      return this.windowSize.width < 1024
    },
    isInboxDocumentActivated() {
      const actions = this.$store.state.actions
      return actions.some(action => action.id === '304')
    },
    iframeTokenValid() {
      return this.$iframeMessages.isTokenValid()
    },
    showExpiredPasswordAlert: {
      get() {
        return this.$store.state.profile.expired_password && this.$store.getters['sichernConnect/isAlreadyLinked'] && !this.dismissedExpiredAlert
      },
      set(val) {
        if (!val) this.dismissedExpiredAlert = true
      }
    }
  }
}
</script>
<style scoped>
.empty-state {
  min-height: calc(100vh - 40px - 64px - 80px);
}
.main--container {
  min-height: calc(100vh - 40px - 64px - 80px);
  grid-template-columns: 396px 900px;
  grid-column-gap: 10px;
  display: grid;
}

@media only screen and (max-width: 1023px) {
  .main--container {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media screen and (min-width: 1024px) and (max-width: 1280px) {
  .container {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 100%;
    flex: 1 1 100%;
    margin: auto;
    padding: 0;
    width: 100%;
  }
  .main--container {
    min-height: calc(100vh - 40px - 64px - 80px);
    grid-template-columns: 295px 900px;
    grid-column-gap: 10px;
    display: grid;
  }
}
</style>
